"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELD_MAP = new Map([
    ['language', 'language'],
    ['pageCount', 'number-of-pages'],
    ['publisher', 'publisher'],
    ['title', 'title'],
]);
